// src/frontend/common/FormLayout.jsx
const DEFAULT_IMG = `${process.env.PUBLIC_URL || ""}/img/login-side.png`;
const PRODUCTION_HOST = "www.smilesanalytics.com";
const isProduction = window.location.hostname === PRODUCTION_HOST;

export default function FormLayout({
  children,
  sideImage = DEFAULT_IMG, // you can override from pages if you want
}) {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      {!isProduction && (
        <div className="bg-palette-yellow-badge text-palette-yellow-primary text-center text-sm font-bold py-1 tracking-wide">
          ⚠ TESTING ENVIRONMENT ⚠
        </div>
      )}
      <div className="flex-1 grid md:grid-cols-2">
        {/* Left: form */}
        <div className="flex items-center justify-center p-6">{children}</div>

        {/* Right: decorative image */}
        <div className="hidden md:block relative overflow-hidden rounded-bl-[140px]">
          <img
            src={sideImage}
            alt=""
            className="absolute inset-0 h-full w-full object-cover"
            draggable="false"
          />
        </div>
      </div>
    </div>
  );
}
